<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Commandes individuelles</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center justify-center>
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        
        <!-- Command success/error alert -->
        <v-alert :color="colorCmd"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close_Cmd"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="typeCmd">
          {{ textCmd }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select
                  :items="selectDates" @change="depthDate"
                  class="centered-input align-center" dense
                  filled
                  full-width
                  height="45px"
                  hide-details="true"
                  item-text="name"
                  item-value="value"
                  persistent-hint return-object solo style="z-index: 200"
                  v-model="depthVal">
                <template v-slot:selection="{ item }">
                  <span class="d-flex justify-center" style="width: 100%;">
                    {{ item.name }}
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn @click="initCmd()" block class="custom-btn white--text"
                     color="#009688"
                     height="45px" large>
                <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                <span>Passer commande</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4" elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>

    <!-- OrderEnhancer for enhanced order processing -->
    <OrderEnhancer
      ref="orderEnhancer"
      :isProcessingOrder="isProcessingOrder"
      @orderSuccess="handleOrderSuccess"
      @orderFailed="handleOrderFailed"
      @orderCancelled="handleOrderCancelled"
    />
  </v-container>
</template>

<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import OrderEnhancer from "../../Order/OrderEnhancer.vue";
import {heightDate} from "../../../helper/hauteur";
import * as XLSX from 'xlsx';
import imageToBase64 from "image-to-base64/browser";
import jsPDF from "jspdf";
import MotionPicture from "../../../assets/Fonts/MotionPicture-normal";
import Handsontable from "handsontable";
import Swal from 'sweetalert2';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import {French} from "flatpickr/dist/l10n/fr.js";

const listGuess = ['80001', '80002', '80003', '80004', '80005', '80006', '80007', '80008', '80009', '80010']
// Liste des utilisateurs qui ne doivent PAS vérifier le statut "non planifiés"
const exemptUserIds = ["91804", "92204", "19001", "20052", "92208", "22014", "19129", "18046", "19385", "18108", "18004", "18075", "18106", "Admin"];

// Styles CSS améliorés pour un design plus harmonieux
const customStyles = `
<style>
  /* Palette de couleurs harmonieuses */
  :root {
    --primary-color: #00796B;       /* Vert teal foncé - couleur principale */
    --primary-light: #26A69A;       /* Vert teal plus clair */
    --secondary-color: #455A64;     /* Bleu-gris foncé - couleur secondaire */
    --secondary-light: #607D8B;     /* Bleu-gris plus clair */
    --text-on-dark: #FFFFFF;        /* Texte sur fond foncé */
    --text-on-light: #263238;       /* Texte sur fond clair */
    --background-light: #F5F8FA;    /* Fond clair */
    --success-color: #4CAF50;       /* Vert pour les succès */
    --error-color: #F44336;         /* Rouge pour les erreurs */
  }

 /* Style pour les alertes inline dans le modal */
  #modal-inline-alert {
    width: 100%;
    margin-bottom: 20px;
    transition: all 0.3s ease;
  }

  #modal-inline-alert .v-icon {
    vertical-align: middle;
  }

/* Styles pour résoudre le problème de lisibilité des select dropdown */
  .v-select__selections {
    color: white !important; /* Texte blanc sur le select fermé */
  }

  .v-menu__content .v-list-item__title,
  .v-menu__content .v-list-item__content,
  .v-select__selection--comma,
  .v-select .v-select__selection {
    color: white !important; /* Garder le texte blanc quand le select est fermé */
  }

  /* Style spécial pour les options dans le dropdown */
  .v-menu__content .v-list,
  .v-menu__content .v-list-item {
    color: #333 !important; /* Texte foncé dans le dropdown */
    background-color: white !important;
  }

  /* Style spécial pour l'option sélectionnée dans le dropdown */
  .v-menu__content .v-list-item--active {
    background-color: rgba(38, 166, 154, 0.1) !important;
    color: var(--primary-color) !important;
  }

  /* Style au survol des options */
  .v-menu__content .v-list-item:hover {
    background-color: rgba(38, 166, 154, 0.05) !important;
  }

  /* Pour les selects personnalisés dans SweetAlert, ces styles sont différents */
  #orderDate, #timeMeal, #mealName {
    color: var(--text-on-light) !important; /* Texte foncé pour meilleur contraste */
    background-color: white !important; /* Fond blanc */
  }

  /* Quand les selects sont ouverts */
  .flatpickr-calendar,
  .flatpickr-calendar .flatpickr-day,
  .flatpickr-calendar .flatpickr-monthDropdown-months,
  .flatpickr-calendar .flatpickr-month,
  .flatpickr-calendar .numInputWrapper input {
    color: #333 !important; /* Texte foncé dans le calendrier */
  }

  /* Amélioration du contraste dans le calendrier */
  .flatpickr-months .flatpickr-month {
    background-color: var(--primary-color) !important;
  }

  .flatpickr-current-month .flatpickr-monthDropdown-months,
  .flatpickr-current-month .numInputWrapper span,
  .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month,
  .flatpickr-current-month .numInputWrapper input.cur-year {
    color: white !important; /* Texte blanc sur fond vert */
  }

  .flatpickr-current-month .numInputWrapper span.arrowUp:after,
  .flatpickr-current-month .numInputWrapper span.arrowDown:after {
    border-color: white transparent !important; /* Couleur des flèches */
  }

  .flatpickr-months .flatpickr-prev-month svg,
  .flatpickr-months .flatpickr-next-month svg {
    fill: white !important; /* Couleur des flèches précédent/suivant */
  }

  .flatpickr-weekdays {
    background-color: var(--background-light) !important;
  }

  span.flatpickr-weekday {
    color: var(--secondary-color) !important;
    font-weight: 600 !important;
  }

  .flatpickr-day.selected {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
    color: white !important; /* Texte blanc sur jour sélectionné */
  }

  .flatpickr-day.today {
    border-color: var(--primary-color) !important;
    color: var(--primary-color) !important;
    font-weight: bold !important;
  }

  /* Style spécifique pour aujourd'hui quand il est sélectionné */
  .flatpickr-day.today.selected {
    background-color: var(--primary-color) !important;
    border-color: var(--primary-color) !important;
    color: white !important; /* Texte blanc pour meilleur contraste */
    font-weight: bold !important;
  }

  .flatpickr-day:hover {
    background-color: rgba(38, 166, 154, 0.2) !important;
  }

  /* Options des selects personnalisés dans SweetAlert */
  #timeMeal option, #mealName option {
    color: #333 !important; /* Texte foncé dans les options de dropdown */
    background-color: white !important;
  }

  /* Styles personnalisés pour les composants du modal */
  .swal2-popup {
    width: 90% !important;
    max-width: 500px !important;
    font-family: 'Roboto', sans-serif;
  }

  .swal2-title {
    font-size: 18px !important;
    text-align: center !important;
    color: var(--secondary-color) !important;
    font-weight: 600 !important;
  }

  .command-form {
    padding: 16px;
  }

  .form-row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    margin-bottom: 20px;
  }

  .form-group {
    flex: 1;
    min-width: 200px;
    margin: 0 10px;
    padding: 12px;
    border-radius: 8px;
    position: relative;
    background-color: white !important;
    border-left: 4px solid var(--primary-color) !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: all 0.2s ease;
  }

  .form-group:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }

  .form-group label {
    display: block;
    text-align: center;
    font-weight: 600;
    margin-bottom: 10px;
    font-size: 16px; /* Police agrandie de 14px à 16px */
    color: var(--primary-color) !important;
    text-transform: uppercase; /* Pour plus d'impact visuel */
    letter-spacing: 0.5px; /* Meilleur espacement des lettres */
  }

  .form-group input,
  .form-group select {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    background: white !important;
    text-align: center;
    font-weight: 500;
    font-size: 15px;
    color: var(--text-on-light) !important;
  }

  .form-group input::placeholder {
    opacity: 0.7;
    text-align: center;
    color: #999 !important;
  }

  /* Style pour le conteneur Handsontable */
  #commandTableContainer {
    margin-top: 20px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  }

  /* Styles spécifiques pour le flatpickr */
  .flatpickr-calendar {
    z-index: 99999 !important;
  }

  /* Style pour le bouton Valider et Annuler - Design amélioré avec police plus grande */
  .swal2-actions {
    gap: 25px !important; /* Augmenté de 20px à 25px */
    flex-direction: row-reverse !important;
    margin-top: 5px !important; /* Ajouté pour plus d'espace en haut */
    justify-content: center !important; /* Assure un centrage parfait */
  }

  .swal2-confirm,
  .swal2-cancel {
    padding: 18px 35px !important; /* Augmenté de 14px/30px à 18px/35px */
    font-size: 18px !important; /* Augmenté de 16px à 18px */
    text-transform: uppercase !important;
    font-weight: 700 !important; /* Plus gras qu'avant (600 → 700) */
    letter-spacing: 0.8px !important; /* Augmenté de 0.5px à 0.8px */
    color: white !important;
    border-radius: 6px !important; /* Arrondi légèrement augmenté */
    transition: all 0.2s ease !important;
    box-shadow: 0 3px 8px rgba(0,0,0,0.3) !important; /* Ombre plus prononcée */
    position: relative !important;
    overflow: hidden !important;
    min-width: 160px !important; /* Augmenté de 130px à 160px */
    height: 60px !important; /* Hauteur fixe ajoutée */
    line-height: 24px !important; /* Ligne plus haute pour le texte */
  }

  .swal2-confirm {
    background: linear-gradient(135deg, var(--primary-light) 0%, var(--primary-color) 100%) !important;
    border: none !important;
  }

  .swal2-cancel {
    background: linear-gradient(135deg, var(--secondary-light) 0%, var(--secondary-color) 100%) !important;
    border: none !important;
  }

  .swal2-confirm:hover,
  .swal2-cancel:hover {
    transform: translateY(-3px) !important; /* Plus prononcé (-2px → -3px) */
    box-shadow: 0 5px 12px rgba(0,0,0,0.4) !important; /* Ombre plus intense */
    filter: brightness(110%) !important; /* Ajout de luminosité au survol */
  }

  .swal2-confirm:active,
  .swal2-cancel:active {
    transform: translateY(1px) !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.2) !important;
  }

  .swal2-confirm::before,
  .swal2-cancel::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0) 100%);
    transition: all 0.6s ease;
  }

  .swal2-confirm:hover::before,
  .swal2-cancel:hover::before {
    left: 100%;
  }

  /* Style spécifique pour le bouton Valider pour le mettre plus en évidence */
  .swal2-confirm {
    box-shadow: 0 3px 10px rgba(0,150,136,0.4) !important;
  }

  .swal2-confirm:hover {
    box-shadow: 0 5px 15px rgba(0,150,136,0.6) !important;
  }

  /* Ajout d'un effet de pulsation subtil pour attirer l'attention */
  @keyframes subtlePulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.03); }
    100% { transform: scale(1); }
  }

  .swal2-confirm {
    animation: subtlePulse 2s infinite;
  }

  .swal2-confirm:hover {
    animation: none;
  }

  /* Style pour les selects */
  .form-group select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2300796B'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 24px;
    padding-right: 30px;
  }

  /* Style pour le statut de chargement */
  .command-modal-loader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(3px);
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .command-modal-spinner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 50%;
    width: 100px;
    height: 100px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  }

  .command-modal-spinner {
    width: 60px;
    height: 60px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid var(--primary-color);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  .loader-text {
    font-size: 12px;
    color: var(--primary-color);
    margin-top: 10px;
    font-weight: 500;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Toasts d'alertes améliorés */
  .swal2-toast {
    background: white !important;
    box-shadow: 0 3px 10px rgba(0,0,0,0.2) !important;
    padding: 15px !important;
  }

  .swal2-toast .swal2-title {
    font-size: 14px !important;
    color: #333 !important;
  }

  /* En-tête du modal */
  .custom-modal-header {
    background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%) !important;
    color: white !important;
  }

  /* Style pour la toolbar */
  .v-toolbar__title {
    font-size: 20px !important; /* Agrandir le titre */
    width: 100% !important; /* Prendre toute la largeur */
    text-align: center !important; /* Centrer le texte */
    margin-left: 40px !important; /* Compensation pour l'icône */
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
    }

    .form-group {
      margin: 5px 10px;
    }
  }
</style>
`;

function cellActualDateRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.CheckboxRenderer.apply(this, arguments);

  if (column === 1) {
    td.className = "colYellow htCenter htMiddle";
  }
}

function cellRedAnonymeRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  if (column === 2) {
    td.className = "colRed htCenter htMiddle";
  }
}

function cellGreenAnonymeRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  if (column === 2) {
    td.className = "colGreen htCenter htMiddle";
  }
}

function cellPastDateRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.CheckboxRenderer.apply(this, arguments);

  if (column === 1) {
    td.className = "colBrown htCenter htMiddle";
  }
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "commandes",
  components: {HotTable, OrderEnhancer},
  data: function () {
    return {
      lastMenuRequestTime: 0,
      sigleRestaurateur: "",
      isMobile: isMobileDevice(),
      isProcessingOrder: false, // For OrderEnhancer
      isManuallyDeleting: false, // To prevent double deletion
      namePDFile: "Détails des commandes ",
      heading: "Commandes du",
      isListMeal: false,
      disableMainBtn: false,
      dateMinDP: "",
      lastHighlitedRow: null,
      modaldc: null,
      searchName: "",
      getShiftDateChoosed: "",
      getBrigade: sessionStorage.getItem("brigade"),
      menu2: null,
      type: null,
      elapse: null,
      loading: false,
      loading2: false,
      toObject: [],
      toObjectCmd: [],
      timeMeal: [],
      selectDates: depthDate,
      selectDatesHeight: heightDate,
      depthVal: {
        name: "Profondeur 7 jours",
        value: "7"
      },
      heightVal: {
        name: "Hauteur 7 jours",
        value: "7"
      },
      depthValToday: {
        name: "Profondeur Aujourd'hui",
        value: "0"
      },
      heightValToday: {
        name: "Hauteur Aujourd'hui",
        value: "0"
      },
      editedItem: {
        orderDate: moment().toISOString().substr(0, 10),
        userId: "",
        timeMeal: "Déjeuner",
        reasonAbsence: "",
        startDate: moment().toISOString().substr(0, 10),
        endDate: moment().toISOString().substr(0, 10),
        absenceObservations: "",
        onGoing: "",
        restaurateur: ""
      },
      editedItemCmd: {
        orderDate: moment().toISOString().substr(0, 10),
        userId: "",
        nameMeal: "",
        timeMeal: "Déjeuner",
        reasonAbsence: "",
        startDate: moment().toISOString().substr(0, 10),
        endDate: moment().toISOString().substr(0, 10),
        absenceObservations: "",
        onGoing: "",
        restaurateur: ""
      },
      toObjectNoHeader: [],
      listMeals: [],
      timeMealtypes: ["Déjeuner", "Diner"],
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      colorCmd: "",
      file: "",
      alertCmd: false,
      textCmd: "",
      typeCmd: "",
      bYesMeal: false,
      bOrderPossible: false,
      editedIndex: -1,
      errors: [],
      errorsCmd: [],
      excelData: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: {
          items: {
            remove_row: {
              name: "Supprimer la ligne"
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 2, 3, 4, 7, 11, 12, 15],
          indicators: false
        },
        colHeaders: [
          "Id", "Annuler", "Matricule", "Nom", "Prénoms", "Brigade", "Shift", "N° commande", "Date commande", "Horaire repas",
          "Nom du menu", "Prix du menu", "Observations", "Date création", "Matricule créateur", "Anonyme", "Restaurant"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Annuler", width: "120px", type: "checkbox"},
          {title: "Matricule", width: "120px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénoms", width: "200px", readOnly: true},
          {title: "Brigade", width: "130px", readOnly: true},
          {title: "Shift", width: "150px", readOnly: true},
          {title: "N° commande", width: "160px", readOnly: true},
          {
            title: "Date commande",
            width: "150px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            readOnly: true
          },
          {title: "Horaire repas", width: "130px", readOnly: true},
          {title: "Nom du menu", width: "250px", readOnly: true},
          {title: "Prix du menu", width: "160px", readOnly: true},
          {title: "Observations", width: "160px"},
          {
            title: "Date de création",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px", readOnly: true},
          {title: "Anonyme", width: "120px", type: "checkbox"},
          {title: "Restaurant", width: "120px", readOnly: true}
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};
          let strDate;

          if (col === 2) {
            const cellValue = this.instance.getSourceDataAtCell(row, 2);
            let bAnonyme = this.instance.getSourceDataAtCell(row, 15);

            if (listGuess.includes(cellValue) || (bAnonyme === true)) {
              if (listGuess.includes(cellValue)) {
                cellProperties.readOnly = false;
                cellProperties.renderer = cellRedAnonymeRenderer;
              } else {
                cellProperties.readOnly = true;
                cellProperties.renderer = cellGreenAnonymeRenderer;
              }
            }
          } else if (col === 1) {
            strDate = this.instance.getSourceDataAtCell(row, 8)
            let dateOrder = moment(strDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            let dateActual = moment().format("YYYY-MM-DD")

            if (dateActual === dateOrder) {
              cellProperties.readOnly = false;
              cellProperties.renderer = cellActualDateRenderer;
            } else if (dateActual > dateOrder) {
              cellProperties.readOnly = true;
              cellProperties.renderer = cellPastDateRenderer;
            }
          }

          return cellProperties;
        }
      }
    }
  },
  created() {
    this.getData()
  },
  computed: {
    computedDateFormattedMinStart() {
      return moment().format("YYYY-MM-DD").toString()
      //else return moment().add(1, 'days').format("YYYY-MM-DD").toString()
    },

    computedDateFormattedDCmd() {
      this.getShiftByDay(this.editedItemCmd.orderDate)
      return this.formatDate(this.editedItemCmd.orderDate)
    },
  },
  mounted() {
    window.affectation = this.affectation;
    window.checkThisAgent = this.checkThisAgent;
    window.uncheckThisAgent = this.uncheckThisAgent;
    window.checkAllCommands = this.checkAllCommands;
    window.uncheckAllCommands = this.uncheckAllCommands;
    this.launchCommandDlg()
    this.getData()
  },
  methods: {
    // OrderEnhancer event handlers
    handleOrderSuccess(data) {
      console.log('Order created successfully with enhanced handling:', data)
      // Close SweetAlert if still open
      if (Swal.isVisible()) {
        Swal.close()
      }
    },

    handleOrderFailed(data) {
      console.error('Order creation failed after retries:', data)
      // The error is already shown by OrderEnhancer
    },

    handleOrderCancelled(data) {
      console.log('Order creation cancelled by user:', data)
      // Close any open dialogs
      if (Swal.isVisible()) {
        Swal.close()
      }
    },

    // Nouvelle méthode pour vérifier si une commande est déjà passée pour aujourd'hui
    checkExistingOrder(orderedDate, timeOrdered) {
      return new Promise((resolve) => {
        // Vérifier si une commande existe déjà pour cette date et cet horaire
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/account/numberordersbydateanduserid/` +
                orderedDate + "/" +
                sessionStorage.getItem("userId") + "/" +
                sessionStorage.getItem("userId")
            )
            .then(response => {
              if (response.data.status !== 200) {
                resolve({exists: true, message: "Commande déjà passée pour cette date et cet horaire"});
              } else {
                resolve({exists: false});
              }
            })
            .catch(() => {
              // En cas d'erreur, supposer qu'il n'y a pas de commande pour éviter le blocage
              resolve({exists: false});
            });
      });
    },

    // Nouvelle méthode pour afficher le modal
    showCommandModal() {
      // Create the content HTML for the form
      const modalContent = `
        ${customStyles}
        <div class="command-form">
          <!-- Zone réservée pour les alertes qui sera remplie dynamiquement -->
          <div id="modal-inline-alert"></div>
          <div class="form-row">
            <div class="form-group bg-teal">
              <label>Date commande</label>
              <input type="text" id="orderDate" class="flatpickr" placeholder="Choisir une date" readonly>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group bg-amber">
              <label>Horaire repas</label>
              <select id="timeMeal">
                ${this.timeMealtypes.map(time => `<option value="${time}">${time}</option>`).join('')}
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group bg-orange">
              <label>Nom du menu</label>
              <select id="mealName" ${this.isListMeal ? 'disabled' : ''}>
                <option value="" disabled selected>Sélectionner un menu</option>
                ${this.listMeals.map(meal => `<option value="${meal}">${meal}</option>`).join('')}
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group bg-teal">
              <label>Shift du jour</label>
              <input type="text" id="shiftDisplay" placeholder="Statut du shift" readonly>
            </div>
          </div>
        </div>
      `;

      // Afficher le modal SweetAlert2
      Swal.fire({
        // Supprimez le titre standard
        title: '',
        html: `
    <div class="custom-modal-header" style="
      margin: -10px -10px 5px -10px;
      padding: 15px 20px;
      background: linear-gradient(135deg, #009688 0%, #00796B 100%);
      color: white;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      border-radius: 4px 4px 0 0;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      letter-spacing: 0.5px;
      position: relative;
      overflow: hidden;
    ">
      <div style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0) 100%);
        transform: skewX(-20deg);
        animation: shimmer 3s infinite;
      "></div>
      <div style="position: relative; z-index: 1;">
        <i class="v-icon material-icons" style="vertical-align: middle; margin-right: 10px; font-size: 24px;">restaurant_menu</i>
        Passez votre commande
      </div>
    </div>
    ${modalContent}
    <style>
      @keyframes shimmer {
        0% { transform: translateX(-150%) skewX(-20deg); }
        100% { transform: translateX(150%) skewX(-20deg); }
      }

      /* Style personnalisé pour le bouton de fermeture */
      .swal2-close {
        position: absolute !important;
        top: 25px !important;
        right: 55px !important;
        width: 36px !important;
        height: 36px !important;
        border-radius: 50% !important;
        background-color: rgba(255, 255, 255, 0.2) !important;
        backdrop-filter: blur(2px) !important;
        color: white !important;
        font-size: 20px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        transition: all 0.2s ease !important;
        border: none !important;
        outline: none !important;
        padding: 0 !important;
        opacity: 0.8 !important;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2) !important;
        transform: rotate(0deg) !important;
      }

      .swal2-close:hover {
        background-color: rgba(255, 255, 255, 0.3) !important;
        transform: rotate(90deg) !important;
        opacity: 1 !important;
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3) !important;
      }

      /* Important: supprimer complètement le contenu par défaut */
      .swal2-close {
        font-size: 0 !important; /* Masque le × d'origine */
      }

      /* Ajouter notre icône Material Design */
      .swal2-close::after {
        content: "close" !important;
        font-family: 'Material Icons' !important;
        font-size: 22px !important;
        font-weight: normal !important;
        font-style: normal !important;
        line-height: 1 !important;
        color: white !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
    </style>
  `,
        width: '500px',
        padding: '10px',
        showCancelButton: true,
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Valider',
        confirmButtonColor: '#00796B',
        cancelButtonColor: '#78909C',
        showCloseButton: true,
        customClass: {
          actions: 'swal2-actions'
        },
        // Empêcher SweetAlert de fermer automatiquement
        showLoaderOnConfirm: true,
        // Désactiver la fermeture en cliquant à l'extérieur
        allowOutsideClick: false,
        // Désactiver la fermeture en appuyant sur Échap
        allowEscapeKey: false,
        // Désactiver la fermeture en appuyant sur Entrée
        stopKeydownPropagation: false,
        keydownListenerCapture: true, // Capture les événements de touche
        // Préconfirmation
        preConfirm: () => {
          // Logique de validation
          if (!this.bYesMeal) {
            if (Swal.isVisible()) {
              Swal.showValidationMessage('Veuillez sélectionner un menu valide');
            }
            return false;
          }

          if (!this.bOrderPossible) {
            if (Swal.isVisible()) {
              Swal.showValidationMessage('Commande impossible avec votre statut actuel');
            }
            return false;
          }

          // Appel à sendCmd et retour d'une promesse pour que SweetAlert attende
          return new Promise((resolve) => {
            this.sendCmdWithCallback(resolve);
          });
        },
        // CORRECTION : Modifier la section didOpen() dans showCommandModal()

        didOpen: (modal) => {
          // Fix aria-hidden accessibility issue
          const app = document.getElementById('app');
          if (app) {
            app.removeAttribute('aria-hidden');
          }
          
          // Ajouter un petit délai pour s'assurer que le DOM est complètement chargé
          setTimeout(() => {
            // Initialiser Flatpickr pour la date
            try {
              const fp = flatpickr("#orderDate", {
                defaultDate: this.editedItemCmd.orderDate,
                minDate: this.computedDateFormattedMinStart,
                dateFormat: "d/m/Y",
                locale: French,
                firstDayOfWeek: 1,
                onChange: (selectedDates) => {
                  if (selectedDates && selectedDates.length > 0) {
                    this.editedItemCmd.orderDate = moment(selectedDates[0]).format('YYYY-MM-DD');
                    this.getNameMeal(); // Appel lors du changement
                  }
                },
                onReady: function (dateObj, dateStr, instance) {
                  if (instance && instance.calendarContainer) {
                    instance.calendarContainer.classList.add('centered-calendar');
                  }
                }
              });

              // Vérifier si fp a été correctement initialisé
              if (fp && typeof fp.setDate === 'function') {
                fp.setDate(moment(this.editedItemCmd.orderDate).toDate());
              }
            } catch (error) {
              console.error("Erreur lors de l'initialisation du calendrier:", error);
            }

            // Configurer le sélecteur d'horaire
            const timeMealSelect = document.getElementById('timeMeal');
            if (timeMealSelect) {
              timeMealSelect.value = this.editedItemCmd.timeMeal;
              timeMealSelect.addEventListener('change', () => {
                this.editedItemCmd.timeMeal = timeMealSelect.value;
                this.getNameMeal(); // Appel lors du changement
              });
            }

            // Configurer le sélecteur de menu
            const mealNameSelect = document.getElementById('mealName');
            if (mealNameSelect) {
              // Initialiser avec le message de chargement
              mealNameSelect.innerHTML = '<option value="" disabled selected>Chargement des menus...</option>';
              mealNameSelect.disabled = true;

              // Ajouter l'écouteur d'événements
              mealNameSelect.addEventListener('change', () => {
                this.editedItemCmd.nameMeal = mealNameSelect.value;
                this.bYesMeal = !this.isEmpty(mealNameSelect.value);
              });
            }

            // Afficher le shift du jour
            const shiftDisplay = document.getElementById('shiftDisplay');
            if (shiftDisplay) {
              // Liste des utilisateurs exemptés
              const isExemptUser = exemptUserIds.includes(sessionStorage.getItem("userId"));

              // Pour les utilisateurs exemptés, on n'affiche pas "Chargement..."
              if (isExemptUser) {
                shiftDisplay.value = this.getShiftDateChoosed || "";
              } else {
                shiftDisplay.value = this.getShiftDateChoosed || "Vérification en cours...";
              }
            }

            // ✅ AJOUTER : Appel initial à getNameMeal() pour charger les menus
            // Petit délai pour s'assurer que tous les éléments sont prêts
            setTimeout(() => {
              this.getNameMeal();
            }, 100);

            // Observer les changements de getShiftDateChoosed
            this.$watch('getShiftDateChoosed', (newVal) => {
              const shiftDisplay = document.getElementById('shiftDisplay');
              if (shiftDisplay) {
                const isExemptUser = exemptUserIds.includes(sessionStorage.getItem("userId"));

                if (newVal === "Non planifié(e)" && isExemptUser) {
                  shiftDisplay.value = newVal;
                  shiftDisplay.style.color = "#F44336";
                  shiftDisplay.style.fontWeight = "bold";
                  this.bOrderPossible = true;
                } else {
                  shiftDisplay.value = newVal || "Non planifié(e)";

                  if (newVal === "Absent(e)" || newVal === "Non planifié(e)" || newVal === "Déjà traitée") {
                    shiftDisplay.style.color = "#F44336";
                    shiftDisplay.style.fontWeight = "bold";
                  } else {
                    shiftDisplay.style.color = "#4CAF50";
                    shiftDisplay.style.fontWeight = "bold";
                  }
                }
              }
            });

            // Observer les changements de bYesMeal pour activer/désactiver le bouton
            this.$watch('bYesMeal', (newVal) => {
              const confirmButton = Swal.getConfirmButton();
              if (confirmButton) {
                const isDisabled = !newVal || !this.bOrderPossible;
                confirmButton.disabled = isDisabled;
                confirmButton.style.opacity = isDisabled ? '0.5' : '1';
              }
            });

            // Observer les changements de bOrderPossible
            this.$watch('bOrderPossible', (newVal) => {
              const confirmButton = Swal.getConfirmButton();
              if (confirmButton) {
                const isDisabled = !newVal || !this.bYesMeal;
                confirmButton.disabled = isDisabled;
                confirmButton.style.opacity = isDisabled ? '0.5' : '1';
              }
            });
          }, 50); // Un petit délai de 50ms devrait suffire
        },
        
        willClose: () => {
          // Restore proper aria-hidden state when closing
          const app = document.getElementById('app');
          if (app) {
            app.setAttribute('aria-hidden', 'false');
          }
        }
      });
    },

    async sendCmdWithCallback(resolveCallback) {
      let day, month, year;
      day = this.getDay(this.editedItemCmd.orderDate);
      month = this.getMonth(this.editedItemCmd.orderDate);
      year = this.getYear(this.editedItemCmd.orderDate);

      const dayTmp = this.daysIntoYear(new Date(year, month - 1, day));

      const order = {
        name: dayTmp + "_" + sessionStorage.getItem("userId") + "_" + this.editedItemCmd.timeMeal,
        orderDate: moment(this.editedItemCmd.orderDate).format("YYYY-MM-DD"),
        timeMeal: this.editedItemCmd.timeMeal
      };

      const orderItemsList = [{
        userId: sessionStorage.getItem("userId"),
        observations: null
      }];

      const nameMeal = this.editedItemCmd.nameMeal;
      const dataToSave = {order, orderItemsList, nameMeal};

      // Create the order function with proper error handling
      const orderFunction = async (orderData) => {
        return apiClient.post(
          `${this.$store.getters.user.baseUrl}/order/createListOrderItems/` + sessionStorage.getItem("userId"),
          orderData
        );
      };

      // Check if OrderEnhancer is available, if not, fall back to direct API call
      if (!this.$refs.orderEnhancer) {
        // Fallback to direct API call without enhancement
        return this.sendCmdWithCallbackDirect(resolveCallback, dataToSave, orderFunction);
      }

      // Use OrderEnhancer for better error handling and visual feedback
      this.isProcessingOrder = true;
      
      // Store the function in OrderEnhancer for retry capability
      this.$refs.orderEnhancer.setOriginalFunction(orderFunction);

      try {
        const result = await this.$refs.orderEnhancer.enhanceOrderCreation(orderFunction, dataToSave);
        
        this.isProcessingOrder = false;
        
        if (result.success) {
          const res = result.data;
          
          // Check backend response status
          if (res.data.status === 200) {
            // Success - use v-alert instead of SweetAlert
            this.colorCmd = "#009688";
            this.textCmd = res.data.message;
            this.showAlertCmd('info');

            // Refresh data after a short delay
            setTimeout(() => {
              this.refresh();
            }, 500);

            // Resolve successfully
            resolveCallback(true);
          } else if (res.data.status === 424) {
            // Order already exists - use v-alert
            this.colorCmd = "#F44336";
            this.textCmd = res.data.message || 'Une commande existe déjà pour cette date et cet horaire.';
            this.showAlertCmd('warning');
            resolveCallback(false);
          } else {
            // Other backend error - use v-alert
            this.colorCmd = "#F44336";
            this.textCmd = res.data.message || 'Erreur lors de la création de la commande';
            this.showAlertCmd('warning');
            resolveCallback(false);
          }
        } else {
          // OrderEnhancer handled the error with retry dialog
          // Don't show additional error here as OrderEnhancer already shows it
          resolveCallback(false);
        }
      } catch (error) {
        this.isProcessingOrder = false;
        
        // Handle specific error codes
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.message;
          
          if (status === 424) {
            // Order already exists - use v-alert
            this.colorCmd = "#F44336";
            this.textCmd = message || 'Une commande existe déjà pour cette date et cet horaire.';
            this.showAlertCmd('warning');
          } else if (status === 401) {
            // Session expired - use v-alert and redirect after delay
            this.colorCmd = "#F44336";
            this.textCmd = 'Votre session a expiré. Redirection vers la connexion...';
            this.showAlertCmd('warning');
            
            // Redirect after showing alert
            setTimeout(() => {
              this.$router.push('/login');
            }, 3000);
          } else {
            // Other errors - use v-alert
            this.colorCmd = "#F44336";
            this.textCmd = message || "Une erreur s'est produite lors de l'envoi de la commande";
            this.showAlertCmd('warning');
          }
        } else {
          // Network or other errors - use v-alert
          this.colorCmd = "#F44336";
          this.textCmd = "Erreur de connexion. Vérifiez votre connexion internet.";
          this.showAlertCmd('warning');
        }
        
        resolveCallback(false);
      }
    },

    // Fallback method for when OrderEnhancer is not available
    async sendCmdWithCallbackDirect(resolveCallback, dataToSave, orderFunction) {
      try {
        const response = await orderFunction(dataToSave);
        const res = response;
        
        // Check backend response status
        if (res.data.status === 200) {
          // Success - use v-alert instead of SweetAlert
          this.colorCmd = "#009688";
          this.textCmd = res.data.message;
          this.showAlertCmd('info');
          
          // Refresh the data
          this.getShiftByDay();
          resolveCallback(true);
        } else {
          // Backend error - use v-alert
          this.colorCmd = "#F44336";
          this.textCmd = res.data.message || 'Erreur lors de la création de la commande';
          this.showAlertCmd('warning');
          resolveCallback(false);
        }
      } catch (error) {
        console.error('Direct order creation failed:', error);
        
        // Handle specific error codes
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data?.message;
          
          if (status === 424) {
            // Order already exists - use v-alert
            this.colorCmd = "#F44336";
            this.textCmd = message || 'Une commande existe déjà pour cette date et cet horaire.';
            this.showAlertCmd('warning');
          } else if (status === 401) {
            // Session expired - use v-alert and redirect after delay
            this.colorCmd = "#F44336";
            this.textCmd = 'Votre session a expiré. Redirection vers la connexion...';
            this.showAlertCmd('warning');
            
            // Redirect after showing alert
            setTimeout(() => {
              this.$router.push('/login');
            }, 3000);
          } else {
            // Other errors - use v-alert
            this.colorCmd = "#F44336";
            this.textCmd = message || "Une erreur s'est produite lors de l'envoi de la commande";
            this.showAlertCmd('warning');
          }
        } else {
          // Network or other errors - use v-alert
          this.colorCmd = "#F44336";
          this.textCmd = "Erreur de connexion. Vérifiez votre connexion internet.";
          this.showAlertCmd('warning');
        }
        
        resolveCallback(false);
      }
    },

    refreshAsync() {
      // ✅ Utiliser $nextTick pour éviter de bloquer la fermeture du modal
      this.$nextTick(() => {
        // Délai court pour laisser le modal se fermer proprement
        setTimeout(() => {
          this.getData();
        }, 300);
      });
    },

    launchCommandDlg() {
      if (this.bDisplayOK_PointFocal) {
        this.initCmd();
      }
    },

    checkThisAgent(row) {
      this.loading = true
      this.$refs.hotTableCmd.hotInstance.suspendRender();

      this.$refs.hotTableCmd.hotInstance.setDataAtCell(row, 1, true)

      this.$refs.hotTableCmd.hotInstance.render();
      this.$refs.hotTableCmd.hotInstance.resumeRender();
      this.loading = false
    },
    uncheckThisAgent(row) {
      this.loading = true
      this.$refs.hotTableCmd.hotInstance.suspendRender();

      this.$refs.hotTableCmd.hotInstance.setDataAtCell(row, 1, false)

      this.$refs.hotTableCmd.hotInstance.render();
      this.$refs.hotTableCmd.hotInstance.resumeRender();
      this.loading = false
    },
    checkAllCommands() {
      this.loading = true
      this.$refs.hotTableCmd.hotInstance.suspendRender();

      let i;
      const lg = this.$refs.hotTableCmd.hotInstance.countRows();

      for (i = 0; i < lg; i++) {
        this.$refs.hotTableCmd.hotInstance.setDataAtCell(i, 1, true)
      }

      this.$refs.hotTableCmd.hotInstance.render();
      this.$refs.hotTableCmd.hotInstance.resumeRender();
      this.loading = false
    },
    uncheckAllCommands() {
      this.loading = true
      this.$refs.hotTableCmd.hotInstance.suspendRender();

      let i;
      const lg = this.$refs.hotTableCmd.hotInstance.countRows();
      for (i = 0; i < lg; i++) {
        this.$refs.hotTableCmd.hotInstance.setDataAtCell(i, 1, false)
      }

      this.$refs.hotTableCmd.hotInstance.render();
      this.$refs.hotTableCmd.hotInstance.resumeRender();
      this.loading = false
    },
    afterSelectionEndCmd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTableCmd.hotInstance.countCols(); i++) {
          this.$refs.hotTableCmd.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTableCmd.hotInstance.countCols(); i++) {
        this.$refs.hotTableCmd.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTableCmd.hotInstance.render()
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    clearedCmd() {
      this.getShiftDateChoosed = "";
      this.getShiftByDay();
    },
    getShiftByDay(date) {
      // Vérifier si l'utilisateur actuel est dans la liste des exemptés
      const isExemptUser = exemptUserIds.includes(sessionStorage.getItem("userId"));

      this.bOrderPossible = false;
      this.getShiftDateChoosed = "";

      if (this.isEmpty(date)) {
        date = this.editedItemCmd.orderDate;
      }

      if (!this.isEmpty(this.$store.getters.user)) {
        // Vérification si une commande existe déjà
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/account/numberordersbydateanduserid/` + date + "/" + sessionStorage.getItem("userId") + "/" + sessionStorage.getItem("userId")
            )
            .then(response => {
              if (response.data.status !== 200) {
                this.getShiftDateChoosed = "Déjà traitée";
                return;
              }

              if (!this.isEmpty(this.$store.getters.user)) {
                apiClient
                    .get(
                        `${this.$store.getters.user.baseUrl}/account/presencesbyuserid/` + date + "/" + sessionStorage.getItem("userId") + "/" + sessionStorage.getItem("userId")
                    )
                    .then(response => {
                      if (response.data.status !== 200) {
                        // Si l'utilisateur est exempté, on ignore le statut "non planifié"
                        if (isExemptUser) {
                          // Ne pas afficher "Non planifié(e)" pour ces utilisateurs
                          this.getShiftDateChoosed = "";
                          this.bOrderPossible = true;
                        } else {
                          this.getShiftDateChoosed = "Non planifié(e)";
                        }
                        return;
                      }

                      apiClient
                          .get(
                              `${this.$store.getters.user.baseUrl}/account/readytoorder/` + date + "/" + this.editedItemCmd.timeMeal + "/0/" + sessionStorage.getItem("userId")
                          )
                          .then(response => {
                            this.loading = false;
                            let newObj = response.data.datas;

                            if (response.data.status !== 200) {
                              this.textCmd = response.data.message;
                              this.showInlineAlert('warning');
                              return;
                            }

                            if ((newObj.length !== 0) && (newObj[0]["id"] === "-1")) {
                              this.getShiftDateChoosed = "Absent(e)";
                              return;
                            }

                            newObj.forEach((item) => {
                              this.getShiftDateChoosed = item["shiftName"];
                            });

                            if ((newObj.length !== 0) && ((this.getShiftDateChoosed !== "Non planifié(e)" && this.getShiftDateChoosed !== "Absent(e)") || this.getBrigade.toLowerCase() === "direction"
                                || this.getBrigade.toLowerCase() === "assa" || this.getBrigade.toLowerCase() === "tsa")) {
                              this.bOrderPossible = true;
                            } else if (isExemptUser && this.getShiftDateChoosed === "Non planifié(e)") {
                              // Pour les utilisateurs exemptés, même en cas de "Non planifié(e)", on autorise la commande
                              this.getShiftDateChoosed = "";
                              this.bOrderPossible = true;
                            }
                          })
                          .catch(() => {
                            this.loading = false;
                          });
                    })
                    .catch(() => {
                      // En cas d'erreur, autoriser quand même pour les utilisateurs exemptés
                      if (isExemptUser) {
                        this.bOrderPossible = true;
                      }
                    });
              }
            })
            .catch(() => {
              // En cas d'erreur, autoriser quand même pour les utilisateurs exemptés
              if (isExemptUser) {
                this.bOrderPossible = true;
              }
            });
      }
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    initdatetime() {
      this.editedItem.startDate = this.editedItem.endDate = moment().toISOString().substr(0, 10);
      this.editedItem.reasonAbsence = "";
      this.editedItem.userId = "";
      this.editedItem.absenceObservations = "";
      this.listMeals = [];
    },
    initCmd() {
      // Initialiser les valeurs par défaut
      this.editedItemCmd.orderDate = moment().toISOString().substr(0, 10);
      this.editedItemCmd.userId = "";
      this.editedItemCmd.nameMeal = "";
      this.editedItemCmd.timeMeal = "Déjeuner";
      this.listMeals = [];
      this.getShiftDateChoosed = "";
      this.bOrderPossible = false;

      // Appeler la méthode pour obtenir les menus
      this.getNameMeal();

      // Afficher le modal amélioré
      this.showCommandModal();
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData()
    },
    isEmpty(str) {
      return (str === null || !str || 0 === str.length || /^\s*$/.test(str));
    },
    getData() {
      // ✅ MODIFIER : Utiliser un indicateur de chargement moins intrusif
      this.loading = true;

      let valeur = this.depthVal.value;

      let str;
      str = `${this.$store.getters.user.baseUrl}/order/ordersbydatedepthbyagent/` +
          moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" +
          sessionStorage.getItem("userId") + "/" + sessionStorage.getItem("userId");

      apiClient
          .get(str)
          .then(response => {
            this.loading = false;
            let tabArray = [];
            let newObj = response.data.datas;

            String.prototype.capitalize = function (allWords) {
              return (allWords) ?
                  this.split(' ').map(word => word.capitalize()).join(' ') :
                  this.charAt(0).toUpperCase() + this.slice(1);
            }

            var restaurateursFull = JSON.parse(sessionStorage.getItem("restaurateursFull"));
            let nameResto;

            newObj.forEach((item) => {
              let s2 = item["originProduct"].toLowerCase();

              for (let i = 0; i < restaurateursFull.length - 1; i++) {
                let s1 = restaurateursFull[i].toLowerCase()
                if (s1.localeCompare(s2) === 0) {
                  nameResto = restaurateursFull[i + 1]
                  break;
                }
              }

              tabArray.push([
                item["id"],
                false,
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                item["shiftName"],
                item["orderNumber"],
                this.convertDate(item["orderDate"]),
                item["timeMeal"],
                item["nameMeal"],
                item["priceMeal"],
                item["observations"],
                this.datefull(item["creationDate"]),
                item["originUser"],
                item["anonyme"],
                nameResto
              ])
            })

            // ✅ Mise à jour fluide du tableau
            this.$refs.hotTable.hotInstance.loadData(tabArray);
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
            this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
          })
          .catch(() => {
            this.loading = false;
          });
    },

    getNameMeal() {
      // Add timestamp tracking for race condition prevention
      const requestTime = Date.now();
      this.lastMenuRequestTime = requestTime;

      this.getShiftDateChoosed = "";
      this.bOrderPossible = false;
      this.listMeals = [];
      this.isListMeal = true;

      if (!this.isEmpty(this.editedItemCmd.orderDate) && !this.isEmpty(this.editedItemCmd.timeMeal)) {
        const mealNameSelect = document.getElementById('mealName');
        if (mealNameSelect) {
          mealNameSelect.disabled = true;
          mealNameSelect.innerHTML = '<option>Chargement des menus...</option>';
          mealNameSelect.style.opacity = '0.6';
        }

        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/product/namemeal/` +
                this.editedItemCmd.orderDate + "/" +
                this.editedItemCmd.timeMeal + "/" +
                sessionStorage.getItem("userId")
            )
            .then(response => {
              // Only process if this is the most recent request
              if (requestTime !== this.lastMenuRequestTime) {
                console.log('Ignoring outdated menu response');
                return;
              }

              // Restaurer le select
              if (mealNameSelect) {
                mealNameSelect.style.opacity = '1';
                mealNameSelect.disabled = false;
              }

              let newObj = response.data.datas;

              // ✅ NOW ACTUALLY USE THESE VARIABLES:
              // Vérifier si les menus ont changé avant de mettre à jour l'interface
              const currentMenus = this.listMeals.join(',');
              const newMenus = !this.isEmpty(newObj) ? newObj : '';

              // Si rien n'a changé, ne rien faire pour éviter le scintillement
              if (currentMenus === newMenus && this.bYesMeal === !this.isEmpty(newObj)) {
                return;
              }

              if (!this.isEmpty(newObj)) {
                // Menus disponibles
                const newListMeals = newObj.split(',');
                this.listMeals = newListMeals;

                // Ne changer la valeur que si nécessaire
                if (this.editedItemCmd.nameMeal !== newListMeals[0]) {
                  this.editedItemCmd.nameMeal = newListMeals[0];
                }

                // Mettre à jour les états
                this.bYesMeal = true;
                this.isListMeal = false;

                // Mettre à jour le sélecteur de menu
                if (mealNameSelect) {
                  const currentOptions = Array.from(mealNameSelect.options).map(opt => opt.value);
                  if (JSON.stringify(currentOptions) !== JSON.stringify(newListMeals)) {
                    const currentSelection = mealNameSelect.value;

                    mealNameSelect.innerHTML = '';
                    newListMeals.forEach(meal => {
                      const option = document.createElement('option');
                      option.value = meal;
                      option.textContent = meal;
                      mealNameSelect.appendChild(option);
                    });

                    mealNameSelect.value = newListMeals.includes(currentSelection) ?
                        currentSelection : newListMeals[0];
                  }
                  mealNameSelect.disabled = false;
                }

                // Supprimer les alertes d'erreur précédentes
                const alertEl = document.getElementById('modal-inline-alert');
                if (alertEl) alertEl.remove();

                // Vérifier le statut du shift pour cette date
                this.getShiftByDay(this.editedItemCmd.orderDate);
              } else {
                // Aucun menu disponible
                this.listMeals = [];
                this.editedItemCmd.nameMeal = "";
                this.bYesMeal = false;
                this.isListMeal = true;

                if (mealNameSelect) {
                  mealNameSelect.innerHTML = '<option value="" disabled selected>Pas de menu disponible</option>';
                  mealNameSelect.disabled = true;
                }

                this.showInlineAlert('warning', "Il n'y a pas de menu pour ce jour et cet horaire.");
                this.getShiftByDay(this.editedItemCmd.orderDate);
              }
            })
            .catch((error) => {
              // Only handle error if this is still the most recent request
              if (requestTime !== this.lastMenuRequestTime) {
                return;
              }

              if (mealNameSelect) {
                mealNameSelect.style.opacity = '1';
                mealNameSelect.disabled = false;
              }

              console.error("Erreur lors du chargement des menus:", error);

              this.isListMeal = true;
              this.editedItemCmd.nameMeal = "";
              this.bYesMeal = false;

              this.showInlineAlert('warning', "Erreur lors du chargement des menus.");
              this.getShiftByDay(this.editedItemCmd.orderDate);
            });
      } else {
        this.showInlineAlert('warning', "Sélectionnez une date et un horaire de repas.");
        this.editedItemCmd.nameMeal = "";
        this.bYesMeal = false;
      }
    },

// ✅ AJOUTER cette méthode pour afficher les alertes dans le modal
    showInlineAlert(type, message) {
      let alertContainer = document.getElementById('modal-inline-alert');

      if (message) {
        // Créer ou obtenir le conteneur d'alerte
        if (!alertContainer) {
          alertContainer = document.createElement('div');
          alertContainer.id = 'modal-inline-alert';

          // Insérer l'alerte au début du formulaire
          const formContainer = document.querySelector('.command-form');
          if (formContainer) {
            formContainer.insertBefore(alertContainer, formContainer.firstChild);
          }
        }

        // Définir le style et le contenu de l'alerte
        const backgroundColor = type === 'info' ? '#4CAF50' : '#F44336';
        const icon = type === 'info' ? 'success' : 'warning';

        alertContainer.innerHTML = `
      <div style="
        margin-bottom: 20px;
        padding: 12px 16px;
        border-radius: 4px;
        background-color: ${backgroundColor};
        color: white;
        font-weight: 500;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 5px rgba(0,0,0,0.2);
      ">
        <i class="v-icon mdi mdi-${icon}" style="margin-right: 10px; font-size: 20px;"></i>
        ${message}
        <span style="margin-left: auto; cursor: pointer;" onclick="document.getElementById('modal-inline-alert').remove()">×</span>
      </div>
    `;

        // Auto-fermeture après 5 secondes
        setTimeout(() => {
          const alertEl = document.getElementById('modal-inline-alert');
          if (alertEl) alertEl.remove();
        }, 5000);
      }
    },

    affectation(row) {
      this.listMeals = []
      this.isListMeal = true;
      if (!this.isEmpty(this.editedItemCmd.orderDate) && !this.isEmpty(this.editedItemCmd.timeMeal)) {
        this.loading = true
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/product/namemeal/` + this.editedItemCmd.orderDate + "/" + this.editedItemCmd.timeMeal + "/" + sessionStorage.getItem("userId")
            )
            .then(response => {
              this.loading = false
              let newObj = response.data.datas;

              if (!this.isEmpty(newObj)) {
                this.listMeals = this.isEmpty(newObj) ? [] : newObj.split(',')
                this.editedItemCmd.nameMeal = this.listMeals[0]
                this.bYesMeal = true
                this.isListMeal = false
                this.dismissible_close_Cmd()
                this.getShiftByDay()
              } else {
                this.textCmd = "Pas de menu pour ce jour et cet horaire.";
                this.showAlertCmd('warning')
                this.editedItemCmd.nameMeal = ""
                this.bYesMeal = false
                this.isListMeal = true
                this.getShiftByDay()
              }
            })
            .catch(() => {
              this.loading = false
              this.isListMeal = false
              this.editedItemCmd.nameMeal = ""
              this.bYesMeal = true
              this.getShiftByDay()
            });
      } else {
        this.textCmd = "Pas de menu pour ce jour et cet horaire.";
        this.showAlertCmd('warning')
        this.editedItemCmd.nameMeal = ""
        this.bYesMeal = false
        this.getShiftByDay()
      }
    },
    daysIntoYear(date) {
      return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
    },
    getDay(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}`
    },
    getMonth(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}`
    },
    getYear(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}`
    },
    sendCmd() {
      this.loading2 = true

      const orderItemsList = [];
      const nameMeal = this.editedItemCmd.nameMeal;

      let day, month, year;
      day = this.getDay(this.editedItemCmd.orderDate)
      month = this.getMonth(this.editedItemCmd.orderDate)
      year = this.getYear(this.editedItemCmd.orderDate)

      const dayTmp = this.daysIntoYear(new Date(year, month - 1, day));

      const order = {
        name: dayTmp + "_" + sessionStorage.getItem("userId") + "_" + this.editedItemCmd.timeMeal,
        orderDate: moment(this.editedItemCmd.orderDate).format("YYYY-MM-DD"),
        timeMeal: this.editedItemCmd.timeMeal
      };

      orderItemsList.push({
        userId: sessionStorage.getItem("userId"),
        observations: null
      });

      const dataToSave = {order, orderItemsList, nameMeal};

      apiClient
          .post(`${this.$store.getters.user.baseUrl}/order/createListOrderItems/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading2 = false

            if (res.data.status === 200) {
              this.colorCmd = "#009688"
              this.textCmd = res.data.message
              this.showAlertCmd('info')
            } else {
              this.alertCmd = true
              this.colorCmd = "#F44336"
              this.textCmd = res.data.message;
              this.showAlertCmd('warning')
              return
            }

            this.getShiftByDay()
          })
          .catch(error => {
            this.alertCmd = true
            this.textCmd = error;
            this.loading2 = false
            this.colorCmd = "#F44336"
            this.showAlertCmd('warning')
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.dialog = false;
      this.file = "";
      this.$refs.hotTable.hotInstance.loadData([])
      this.toObject = [this.hotSettings.colHeaders, ...[]]
      this.getShiftDateChoosed = ""
      this.refresh()
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    AlertColorCmd(typeCmd) {
      return typeCmd === "info" ? "#4CAF50" : "#F44336";
    },
    showAlertCmd(typeCmd) {
      this.typeCmd = typeCmd

      let timer = this.showAlertCmd.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlertCmd.timer = setTimeout(() => {
        this.typeCmd = null
      }, 20000)

      this.elapseCmd = 1
      let t = this.showAlertCmd.t
      if (t) {
        clearInterval(t)
      }

      this.showAlertCmd.t = setInterval(() => {
        if (this.elapseCmd === 3) {
          this.elapseCmd = 0
          clearInterval(this.showAlertCmd.t)
        } else {
          this.elapseCmd++
        }
      }, 5000)
    },
    dismissible_close_Cmd() {
      this.elapseCmd = 3
      clearTimeout(this.showAlertCmd.timer)
      clearInterval(this.showAlertCmd.t)
      this.typeCmd = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    closeAlertCmd() {
      this.alertCmd = false
      this.textCmd = ""
      this.errorsCmd = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
      this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
      this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let sBody;

        if (changes[0][1] !== 1) {
          sBody = "Confirmez la modification de la commande."
        } else {
          sBody = "Confirmez l'annulation de la commande."
        }

        // Utilisation de SweetAlert2 au lieu de $dialog
        Swal.fire({
          title: 'Fenêtre de confirmation',
          text: sBody,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#00796B',
          cancelButtonColor: '#607D8B',
          confirmButtonText: 'Confirmer',
          cancelButtonText: 'Annuler'
        }).then((result) => {
          if (result.isConfirmed) {
            this.loading = true
            let obj = {}
            let newObj = {}
            obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

            if (changes[0][1] === 1) {
              apiClient
                  .delete(
                      `${this.$store.getters.user.baseUrl}/order/deleteorderitem/` + obj[0] + `/` + "DELETE/" + sessionStorage.getItem("userId")
                  )
                  .then(res => {
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.depthDate()
                    } else {
                      this.color = "#F44336"
                      this.alert = true
                      this.text = res.data.message;
                      this.dialog = false;
                      this.initdatetime()

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data?.message || "Une erreur s'est produite";
                    this.loading = false
                    this.showAlert('warning')
                  });
            } else if (changes[0][1] === 12) {
              newObj = {
                "id": obj[0],
                "observations": obj[12]
              }

              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/order/modiforderitem/` + sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.depthDate()
                    } else {
                      this.color = "#F44336"
                      this.alert = true
                      this.text = res.data.message;
                      this.dialog = false;
                      this.initdatetime()

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data?.message || "Une erreur s'est produite";
                    this.loading = false
                    this.showAlert('warning')
                  });
            } else if (changes[0][1] === 2) {
              newObj = {
                "id": obj[0],
                "userId": obj[2]
              }

              apiClient
                  .post(
                      `${this.$store.getters.user.baseUrl}/order/affectorder2agent/` + sessionStorage.getItem("userId"),
                      newObj
                  )
                  .then(res => {
                    this.loading = false
                    if (res.data.status === 200) {
                      this.color = "#009688"
                      this.text = res.data.message;
                      this.showAlert('info')
                      this.depthDate()
                    } else {
                      this.color = "#F44336"
                      this.alert = true
                      this.text = res.data.message;
                      this.dialog = false;
                      this.initdatetime()

                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)
                      this.showAlert('warning')
                    }
                  })
                  .catch((err) => {
                    let myData = this.$refs.hotTable.hotInstance.getData()
                    myData[changes[0][0]][changes[0][1]] = changes[0][2]
                    this.$refs.hotTable.hotInstance.loadData(myData)

                    this.alert = true
                    this.color = "#F44336"
                    this.text = err.data?.message || "Une erreur s'est produite";
                    this.loading = false
                    this.showAlert('warning')
                  });
            }
          } else {
            // Si annulé, on revient à l'état précédent
            let myData = this.$refs.hotTable.hotInstance.getData()
            myData[changes[0][0]][changes[0][1]] = changes[0][2]
            this.$refs.hotTable.hotInstance.loadData(myData)
          }
        });
      }
    },
    beforeRemoveRowMe(index, amount) {
      // If we're manually deleting, allow it to proceed
      if (this.isManuallyDeleting) {
        this.isManuallyDeleting = false; // Reset flag
        return true; // Allow the removal
      }

      let rowId = this.$refs.hotTable.hotInstance.getData()[index]

      // Utiliser SweetAlert2 pour la confirmation
      Swal.fire({
        title: 'Fenêtre de confirmation',
        text: 'Confirmez la suppression de la commande.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#F44336', // Keep red for delete action
        cancelButtonColor: '#607D8B',
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler'
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true

          apiClient
              .delete(
                  `${this.$store.getters.user.baseUrl}/order/deleteorderitem/` + rowId[0] + `/` + "DELETE/" + sessionStorage.getItem("userId")
              )
              .then(res => {
                this.loading = false
                if (res.data.status === 200) {
                  // Successfully deleted from backend, now remove from table
                  this.isManuallyDeleting = true; // Set flag to prevent double deletion
                  this.$refs.hotTable.hotInstance.alter('remove_row', index);
                  
                  this.color = "#009688"
                  this.text = res.data.message;
                  this.showAlert('info')
                } else {
                  // Deletion failed, row was never removed so just show error

                  this.color = "#F44336"
                  this.alert = true
                  this.text = res.data.message;
                  this.dialog = false;
                  this.showAlert('warning')
                }
              })
              .catch((err) => {
                this.loading = false
                this.alert = true
                this.color = "#F44336"
                this.text = err.data?.message || "Une erreur s'est produite";
                this.showAlert('warning')

                // Row was never removed, so no need to restore
              });
        } else {
          // User cancelled - row was never removed, so no need to restore
          // Do nothing
        }
      });

      // Toujours retourner false pour empêcher le comportement par défaut
      return false;
    },

    // Méthode utilitaire pour restaurer les données d'une ligne
    restoreRowData(index, rowData) {
      this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", false);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", false);

      this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowData]);

      this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 5, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 6, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 9, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", true);
      this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", true);
    },
  }
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

/* Style amélioré pour les boutons avec meilleur contraste */
.custom-btn {
  width: 222px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); /* Ombre sur le texte pour améliorer la lisibilité */
  font-weight: 600; /* Texte plus gras */
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #FFFFFF !important; /* Blanc plus pur au survol */
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2); /* Ombre légère au survol */
}

/* Styles améliorés pour les inputs avec meilleur contraste */
.v-text-field.v-text-field--filled .v-label,
.v-select.v-select--filled .v-label {
  color: rgba(0, 0, 0, 0.7) !important; /* Étiquette plus foncée */
}

.v-text-field.v-text-field--filled > .v-input__control > .v-input__slot,
.v-select.v-select--filled > .v-input__control > .v-input__slot {
  background: #f5f5f5 !important; /* Fond plus clair pour le contraste */
  border: 1px solid #e0e0e0;
}

.v-text-field.v-text-field--filled:hover > .v-input__control > .v-input__slot,
.v-select.v-select--filled:hover > .v-input__control > .v-input__slot {
  background: #ffffff !important; /* Blanc au survol */
}

.v-text-field--filled.v-input--is-focused > .v-input__control > .v-input__slot,
.v-select--filled.v-input--is-focused > .v-input__control > .v-input__slot {
  background: #ffffff !important; /* Blanc quand focus */
  border-color: #009688; /* Couleur de bordure cohérente avec le thème */
}

.text-cmd-white input {
  color: #000000 !important; /* Texte noir pour contraste maximal */
  font-size: 17px;
  font-weight: bold;
  background-color: #f9f9f9 !important; /* Fond légèrement grisé */
}

.text-white input {
  color: #000000 !important; /* Texte noir au lieu de blanc */
  font-weight: bold;
  background-color: #f9f9f9 !important; /* Fond légèrement grisé */
}

/* Amélioration des styles pour le modal SweetAlert */
.swal2-popup .form-group input,
.swal2-popup .form-group select {
  background-color: rgba(255, 255, 255, 0.25) !important; /* Fond plus blanc pour les inputs */
  font-weight: 600 !important; /* Texte plus gras */
  color: #333333 !important; /* Texte plus foncé */
  text-shadow: none !important; /* Pas d'ombre sur le texte */
}

.swal2-popup .form-group label {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3); /* Ombre sur les labels pour améliorer la lisibilité */
  letter-spacing: 0.5px; /* Espacement des lettres pour améliorer la lisibilité */
  font-weight: 700 !important; /* Label en gras */
}

.colRed {
  color: #D32F2F !important;
  font-weight: bold;
}

.colGreen {
  color: #028A0F !important;
  font-weight: bold;
}

.colYellow {
  background-color: #FFF9C4 !important;
  pointer-events: fill;
}

.colBrown {
  background-color: #D7CCC8 !important;
  pointer-events: none
}

/* Styles pour centrer le calendrier flatpickr */
/* Styles pour centrer le calendrier flatpickr */
.centered-calendar {
  left: 50% !important;
  transform: translateX(-50%) !important;
  position: fixed !important;
  top: 40% !important; /* Position verticale centrée */
  transform: translate(-50%, -50%) !important; /* Centrage parfait */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2) !important; /* Ombre plus prononcée */
  border-radius: 8px !important; /* Coins arrondis */
}

/* Styles supplémentaires pour améliorer l'apparence */
.flatpickr-calendar {
  font-family: 'Roboto', sans-serif !important;
  width: 340px !important; /* Largeur augmentée pour éviter la troncature */
  padding: 10px !important;
  background-color: #ffffff !important;
}

/* Ajustement de la cellule des jours pour éviter la troncature */
.flatpickr-days {
  width: 100% !important; /* S'assurer que le conteneur prend toute la largeur */
  max-width: 320px !important; /* Limiter la largeur maximale */
  padding: 0 6px !important; /* Ajouter un peu de padding horizontal */
}

.dayContainer {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: space-around !important; /* Distribuer l'espace uniformément */
}

/* Ajuster la taille et le centrage des jours */
.flatpickr-day {
  border-radius: 50% !important; /* Jours parfaitement ronds */
  margin: 2px !important;
  height: 38px !important; /* Légèrement réduit */
  line-height: 38px !important;
  width: 38px !important; /* Légèrement réduit */
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  font-size: 14px !important; /* Taille de police réduite */
}

.flatpickr-day.selected {
  background-color: #009688 !important; /* Couleur de thème pour le jour sélectionné */
  border-color: #009688 !important;
}

.flatpickr-day:hover {
  background-color: #e0f2f1 !important; /* Couleur de thème plus claire au survol */
}

.flatpickr-months .flatpickr-month {
  background-color: #009688 !important; /* En-tête en couleur de thème */
  color: white !important;
  border-radius: 5px 5px 0 0 !important;
  height: 50px !important;
}

.flatpickr-current-month {
  padding-top: 10px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

.flatpickr-monthDropdown-months {
  color: white !important;
  font-weight: 600 !important;
}

.flatpickr-weekday {
  background-color: transparent !important;
  color: #546E7A !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

/* Améliore les flèches de navigation */
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  top: 5px !important;
  padding: 5px !important;
  color: white !important;
  fill: white !important;
}

.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  opacity: 1 !important;
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-radius: 50% !important;
}

/* Styles spécifiques pour Flatpickr en mode responsive */
@media (max-width: 768px) {
  .flatpickr-calendar {
    width: 300px !important; /* Largeur réduite pour les petits écrans */
    max-width: 95vw !important; /* Limitation à 95% de la largeur de la fenêtre */
    font-size: 14px !important; /* Police légèrement plus petite */
  }

  .flatpickr-day {
    height: 35px !important;
    line-height: 35px !important;
    width: 35px !important;
    max-width: 35px !important;
    font-size: 13px !important;
  }

  /* Améliorer l'accessibilité des flèches sur mobile */
  .flatpickr-months .flatpickr-prev-month,
  .flatpickr-months .flatpickr-next-month {
    height: 40px !important;
    width: 40px !important;
    padding: 10px !important; /* Zone de toucher plus grande */
  }
}
</style>